import axios from '@axios'

/**
 * @type {import('~typings/store').VuexStoreDefinition}
 */
export default {
    namespaced: true,
    state: {
        items: [],
        categorias: [],
        lineas: [],
        marcas: [],
        solicitudesMarcas: [],
        solicitudesItems: [],
        flujoSolicitudItem: [],
        politicasItems: [],
        semejanzasItems: [],
        saldoItem: null,
        unidadesMedida: [],
        ingresosBodega: [],
        egresosBodega: [],
        solicitudesTransferencia: [],
        solicitudesConsumo: [],
        solicitudesDevolucion: [],
        bodegas: [],
        inventarios: [],
        movimientoItem: [],
        ordenesPedidos: [],
        saldoItemEstablecimiento: [],
        pedidosPendientesAprobacion: [],
        nivelAprobacionOrdenesPedidos: [],
        conceptosAir: [],
        sustentosTributarios: [],
        guiaRemision: [],
    },
    getters: {
        getItems(state) {
            return state.items
        },
        getCategorias(state) {
            return state.categorias
        },
        getLineas(state) {
            return state.lineas
        },
        getMarcas(state) {
            return state.marcas
        },
        getSolicitudesMarcas(state) {
            return state.solicitudesMarcas
        },
        getSolicitudesItems(state) {
            return state.solicitudesItems
        },
        getPoliticasItems(state) {
            return state.politicasItems
        },
        getSemejanzasItems(state) {
            return state.semejanzasItems
        },
        getUnidadesMedida(state) {
            return state.unidadesMedida
        },
        getSaldoItem(state) {
            return state.saldoItem
        },
        getIngresosBodega(state) {
            return state.ingresosBodega
        },
        getEgresosBodega(state) {
            return state.egresosBodega
        },
        getSolicitudesDevolucion(state) {
            return state.solicitudesDevolucion
        },
        getSolicitudesConsumo(state) {
            return state.solicitudesConsumo
        },
        getSolicitudesTransferencia(state) {
            return state.solicitudesTransferencia
        },
        getBodegas(state) {
            return state.bodegas
        },
        getInventarios(state) {
            return state.inventarios
        },
        getOrdenesPedidos(state) {
            return state.ordenesPedidos
        },
        getSaldoItemEstablecimiento(state) {
            return state.saldoItemEstablecimiento
        },
        getPedidosPendientesAprobacion(state) {
            return state.pedidosPendientesAprobacion
        },
        getNivelAprobacionOrdenesPedido(state) {
            return state.nivelAprobacionOrdenesPedidos
        },
        getConceptosAir(state) {
            return state.conceptosAir
        },
        getSustentosTributarios(state) {
            return state.sustentosTributarios
        },
        getGuiaRemision(state) {
            return state.guiaRemision
        },
        getEstablecimiento(state) {
            return state.establecimiento
        },
    },
    mutations: {
        setItems(state, items) {
            state.items = items
        },
        setCategorias(state, categorias) {
            state.categorias = categorias
        },
        setLineas(state, lineas) {
            state.lineas = lineas
        },
        setMarcas(state, marcas) {
            state.marcas = marcas
        },
        setSolicitudesMarcas(state, solicitudesMarcas) {
            state.solicitudesMarcas = solicitudesMarcas
        },
        setSolicitudesItems(state, solicitudesItems) {
            state.solicitudesItems = solicitudesItems
        },
        setFlujoSolicitudItem(state, flujoSolicitudItem) {
            state.flujoSolicitudItem = flujoSolicitudItem
        },
        setPoliticasItems(state, politicasItems) {
            state.politicasItems = politicasItems
        },
        setSemejanzasItems(state, semejanzasItems) {
            state.semejanzasItems = semejanzasItems
        },
        setSaldoItem(state, saldoItem) {
            state.saldoItem = saldoItem
        },
        setUnidadesMedida(state, unidadesMedida) {
            state.unidadesMedida = unidadesMedida
        },
        setIngresosBodega(state, ingresosBodega) {
            state.ingresosBodega = ingresosBodega
        },
        setEgresosBodega(state, egresosBodega) {
            state.egresosBodega = egresosBodega
        },
        setSolicitudesDevolucion(state, solicitudesDevolucion) {
            state.solicitudesDevolucion = solicitudesDevolucion
        },
        setSolicitudesConsumo(state, solicitudesConsumo) {
            state.solicitudesConsumo = solicitudesConsumo
        },
        setSolicitudesTransferencia(state, solicitudesTransferencia) {
            state.solicitudesTransferencia = solicitudesTransferencia
        },
        setBodegas(state, bodegas) {
            state.bodegas = bodegas
        },
        setInventarios(state, inventarios) {
            state.inventarios = inventarios
        },
        setMovimientoItem(state, movimientoItem) {
            state.movimientoItem = movimientoItem
        },
        setOrdenesPedidos(state, ordenesPedidos) {
            state.ordenesPedidos = ordenesPedidos
        },
        setPedidosPendientesAprobacion(state, pedidosPendientesAprobacion) {
            state.pedidosPendientesAprobacion = pedidosPendientesAprobacion
        },
        setSaldoItemEstablecimiento(state, saldoItemEstablecimiento) {
            state.saldoItemEstablecimiento = saldoItemEstablecimiento
        },
        setNivelAprobacionOrdenesPedidos(state, nivelAprobacionOrdenesPedidos) {
            state.nivelAprobacionOrdenesPedidos = nivelAprobacionOrdenesPedidos
        },
        setConceptosAir(state, conceptosAir) {
            state.conceptosAir = conceptosAir
        },
        setSustentosTributarios(state, sustentosTributarios) {
            state.sustentosTributarios = sustentosTributarios
        },
        setGuiaRemision(state, guiaRemision) {
            state.guiaRemision = guiaRemision
        },
        setEstablecimiento(state, establecimiento) {
            state.establecimiento = establecimiento
        },
    },
    actions: {
        /* CATEGORÍAS DE ITEMS */
        fetchCategoriasItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/categorias', {
                        params: data,
                    })
                    .then(response => {
                        commit('setCategorias', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCrearCategoria(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/categorias', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchEliminarCategoria(_, id_categoria) {
            const response = await axios.delete(`/api/auth/inventario-consumo/items/categorias/${id_categoria}`)
            return response
        },

        async fetchModificarCategoria(_, data) {
            const { id_categoria } = data
            const response = await axios.put(`/api/auth/inventario-consumo/items/categorias/${id_categoria}`, data)
            return response
        },

        /* LINEAS DE ITEMS */
        fetchLineasItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/lineas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setLineas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchLineaItemById(_, id_linea) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/items/lineas/${id_linea}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCrearLinea(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/lineas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModificarLinea(_, { id_linea, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/lineas/${id_linea}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDesactivarLinea(_, id_linea) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/items/lineas/${id_linea}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* ÍTEMS */
        async fetchItems({ commit }, params) {
            const response = await axios.get('/api/auth/inventario-consumo/items', { params })
            commit('setItems', response.data)
            return response.data
        },

        async fetchItemxID({ commit }, { id_item, ...data }) {
            return await new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/items/${id_item}`, {
                        params: data,
                    })
                    .then(response => {
                        commit('setItems', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModificarItem(_, { id_item, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm(`/api/auth/inventario-consumo/items/${id_item}`, {
                        ...data,
                        _method: 'PUT',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDesactivarItem(_, id_item) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/items/${id_item}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteItemIventario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/reporte', data, { responseType: 'arraybuffer' })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUnidadesMedida({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/unidad-medida', {
                        params: data,
                    })
                    .then(response => {
                        commit('setUnidadesMedida', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* MARCAS */
        fetchMarcas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/marcas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMarcas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarMarca(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/marcas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarMarca(_, { id_marca, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/marcas/${id_marca}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarMarca(_, id_marca) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/items/marcas/${id_marca}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SOLICITUDES DE MARCAS */
        fetchSolicitudesMarca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/inventario-consumo/items/marcas/solicitudes', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudesMarcas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudesMarcasPorAprobar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/inventario-consumo/items/marcas/solicitudes/por-aprobar', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudesMarcas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSolicitudMarca(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/marcas/solicitudes', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarSolicitudMarca(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/marcas/solicitudes/${id_solicitud}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        aprobarSolicitudMarca(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/marcas/solicitudes/${id_solicitud}/aprobacion`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SOLICITUDES DE ÍTEMS */
        async fetchSolicitudesItem(_, params) {
            const response = await axios.get('/api/auth/inventario-consumo/items/solicitudes', { params })
            return response.data
        },

        fetchSolicitudItemById({ commit }, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/items/solicitudes/${id_solicitud}`)
                    .then(response => {
                        commit('setSolicitudesItems', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarSolicitudItem(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/inventario-consumo/items/solicitudes', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        updateSolicitudItem(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/solicitudes/${id_solicitud}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async aprobarSolicitudItem(_, data) {
            const { id_solicitud, ...info } = data
            const response = await axios.put(
                `/api/auth/inventario-consumo/items/solicitudes/${id_solicitud}/aprobacion`,
                info
            )
            return response
        },

        fetchFlujoSolicitudItem({ commit }, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/items/solicitudes/${id_solicitud}/flujo`)
                    .then(response => {
                        commit('setFlujoSolicitudItem', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        aprobarTributacionContable(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/solicitudes/${id_solicitud}/revision`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* POLÍTICAS DE ÍTEMS */
        fetchPoliticasItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/politicas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPoliticasItems', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPoliticaItemById({ commit }, id_politica) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/items/politicas/${id_politica}`)
                    .then(response => {
                        commit('setPoliticasItems', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarPolitica(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/politicas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        updatePolitica(_, { id_politica, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/items/politicas/${id_politica}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarPolitica(_, id_politica) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/items/politicas/${id_politica}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SEMEJANZAS DE ITEMS */
        fetchSemejanzasItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/semejanzas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSemejanzasItems', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarSemejanza(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/items/semejanzas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* MOVIMIENTOS DE ITEMS */
        fetchMovimientoItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos/calcular-saldo`, { params: data })
                    .then(response => {
                        commit('setMovimientoItem', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Cantidad Órdenes de Pedido */
        fetchCantidadOrdenPedido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos/saldo-orden-pedido`, { params: data })
                    .then(response => {
                        commit('setMovimientoItem', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* INGRESOS DE BODEGA */
        fetchIngresosBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/movimientos', {
                        params: data,
                    })
                    .then(response => {
                        commit('setIngresosBodega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchIngresoBodegaById({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos`, {
                        params: data,
                    })
                    .then(response => {
                        commit('setIngresosBodega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarIngresoBodega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarIngresoBodega(_, { id_ingreso, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/movimientos/${id_ingreso}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        anularIngresoBodega(_, id_ingreso) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/movimientos/${id_ingreso}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* EGRESOS DE BODEGA */
        fetchEgresosBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/movimientos', {
                        params: data,
                    })
                    .then(response => {
                        commit('setEgresosBodega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEgresoBodegaById({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos`, {
                        params: data,
                    })
                    .then(response => {
                        commit('setEgresosBodega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarEgresoBodega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarEgresoBodega(_, { id_egreso, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/movimientos/${id_egreso}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        anularEgresoBodega(_, id_egreso) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/movimientos/${id_egreso}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* TRANSFERENCIAS DE BODEGA */
        guardarTransferenciaBodega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/transferencias', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SOLICITUDES DE TRANSFERENCIA */
        fetchSolicitudesTransferencia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/inventarios/solicitudes/transferencia', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudesTransferencia', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudTransferenciaById({ commit }, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/inventarios/solicitudes/transferencia/${id_solicitud}`)
                    .then(response => {
                        commit('setSolicitudesTransferencia', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSolicitudTransferencia(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/inventarios/solicitudes/transferencia', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarSolicitudTransferencia(_, { id_transferencia, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/inventarios/solicitudes/transferencia/${id_transferencia}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        revisarSolicitudTransferencia(_, { id_transferencia, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/api/auth/inventario-consumo/inventarios/solicitudes/transferencia/${id_transferencia}/revision`,
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SOLICITUDES DE CONSUMO */
        fetchSolicitudesConsumo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/inventarios/solicitudes/consumo', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudesConsumo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudConsumoById({ commit }, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/inventarios/solicitudes/consumo/${id_solicitud}`)
                    .then(response => {
                        commit('setSolicitudesConsumo', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSolicitudConsumo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/inventarios/solicitudes/consumo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarSolicitudConsumo(_, { id_consumo, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/inventarios/solicitudes/consumo/${id_consumo}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        revisarSolicitudConsumo(_, { id_consumo, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/inventarios/solicitudes/consumo/${id_consumo}/revision`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SOLICITUDES DE DEVOLUCIÓN */
        fetchSolicitudesDevolucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/inventarios/solicitudes/devolucion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudesDevolucion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudDevolucionById({ commit }, id_solicitud_devolucion) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/inventarios/solicitudes/devolucion/${id_solicitud_devolucion}`)
                    .then(response => {
                        commit('setSolicitudesDevolucion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSolicitudDevolucion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/inventarios/solicitudes/devolucion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarSolicitudDevolucion(_, { id_solicitud_devolucion, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/api/auth/inventario-consumo/inventarios/solicitudes/devolucion/${id_solicitud_devolucion}`,
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        revisarSolicitudDevolucion(_, { id_solicitud_devolucion, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `/api/auth/inventario-consumo/inventarios/solicitudes/devolucion/${id_solicitud_devolucion}/revision`,
                        data
                    )
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* BODEGAS */
        fetchBodegas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/inventarios/bodegas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setBodegas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearBodega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/inventarios/bodegas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarBodega(_, { id_bodega, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/inventarios/bodegas/${id_bodega}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarBodega(_, id_bodega) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/inventarios/bodegas/${id_bodega}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* INVENTARIOS */
        fetchInventarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/inventarios', {
                        params: data,
                    })
                    .then(response => {
                        commit('setInventarios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearInventario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/inventarios', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarInventario(_, { id_inventario, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/inventarios/${id_inventario}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarInventario(_, id_inventario) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/inventario-consumo/inventarios/${id_inventario}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* REPORTES DE INVENTARIO */
        async fetchInfoKardex(_, data) {
            return await new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/reportes-inventario/kardex', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchMovimientosInventario(_, data) {
            return await new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/reportes-inventario/movimientos', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchEstadosInventario(_, data) {
            return await new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/reportes-inventario/estados', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchInfoStockMinimo(_, data) {
            return await new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/reportes-inventario/stock-minimo', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteResumenInventario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/reportes-inventario/resumen-inventario', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchReporteCostoKardex(_, data) {
            return new Promise((resolve, reject) => {
                if (data.tipoData === '1versionexcel') {
                    axios
                        .post('/api/auth/inventario-consumo/reportes-inventario/costo-kardex', data)
                        .then(response => {
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                } else {
                    axios
                        .post('/api/auth/inventario-consumo/reportes-inventario/costo-kardex', data, {
                            responseType: 'arraybuffer',
                        })
                        .then(response => {
                            resolve(response)
                        })
                        .catch(error => {
                            reject(error)
                        })
                }
            })
        },
        fetchOrdenesPedidosPendientesAprobacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/inventario-consumo/inventarios/orden-pedido/pedidos-pendientes-aprobacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPedidosPendientesAprobacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarOrdenPedido(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/inventario-consumo/inventarios/orden-pedido/aprobar-orden-pedido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrdenesPedidos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/inventarios/orden-pedido', {
                        params: data,
                    })
                    .then(response => {
                        commit('setOrdenesPedidos', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrdenPedidoById({ commit }, id_orden_pedido) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/inventarios/orden-pedido/${id_orden_pedido}`)
                    .then(response => {
                        commit('setOrdenesPedidos', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        crearOrdenPedido(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/inventarios/orden-pedido', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarOrdenPedido(_, { id_orden_pedido, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/inventario-consumo/inventarios/orden-pedido/${id_orden_pedido}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchNivelAprobacionOrdenPedido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/inventario-consumo/inventarios/nivel-aprobacion-orden-pedido/', { params: data })
                    .then(response => {
                        commit('setNivelAprobacionOrdenesPedidos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateNivelAprobacionOrdenPedido(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/inventario-consumo/inventarios/nivel-aprobacion-orden-pedido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateNivelAprobacionOrdenPedido(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(
                        `api/auth/inventario-consumo/inventarios/nivel-aprobacion-orden-pedido/${data.id_config_aprobacion}`,
                        data
                    )
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSustentosTributarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/items/lineas/sustentos-tributarios', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSustentosTributarios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* GENERAR PDF GUIA REMISION */
        fetchPDFGuiaRemision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/guia-remision/pdf-guia-remision', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        commit('setGuiaRemision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        /* XML DE GUIA DE REMISION */
        fetchXMLGuiaRemision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/guia-remision/xml-guia-remision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        /* VISUALIZAR PDF GUIAS REMISION */
        visualizarPDFGuiaRemision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/guia-remision/view-pdf-guia-remision', data, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        /* GUARDAR GUIA DE REMISION */
        guardarGuiaRemision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/guia-remision', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* DESCARGAR ZIP GUIA DE REMISION */
        descargarGuiaRemision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/guia-remision/zip-guia-remision', data, {
                        responseType: 'blob',
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* OBTENER ESTABLECIMIENTO */
        fetchEstablecimientoGuiaRemision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos/guia-remision/establecimiento`, { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* OBTENER DESTINO TRANSFERENCIA*/
        getDestinoTransferenciaById(_, id_egreso) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos/transferencias/${id_egreso}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* OBTENER COMPROBACION DE GUARDADO GUIA REMISION */
        comprobacionGuardadoGuiaRemision(_, id_egreso) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos/guia-remision/comprobacion-guardado/${id_egreso}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        comprobacionGuardadoXMLGuiaRemision(_, id_guia) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/inventario-consumo/movimientos/guia-remision/verificar-guardado-xml/${id_guia}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        validarXMLGuiaRemision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/movimientos/guia-remision/validar-xml-guia-remision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* CONTENIDO DE BODEGA */
        fetchContenidoBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/contenido-bodega', {
                        params: data,
                    })
                    .then(response => {
                        commit('setContenidoBodega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateContenidoBodega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/inventario-consumo/contenido-bodega', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSwitchContenidoBodega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/inventario-consumo/contenido-bodega/switch', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
